export type PageFocusTarget = {
  id: string
  jsName?: string
}

/**
 * Swing Page.requestFocus selects the tab. Persist the same choice as the last
 * PAGE is_focused state and clear the flag on the other pages.
 */
export function applyPageFocusStates(
  states: unknown[] | null | undefined,
  page: PageFocusTarget,
): any[] {
  const targetId = String(page.id ?? '').trim()
  const jsName = String(page.jsName ?? '').trim()
  const prev = Array.isArray(states) ? states : []
  let found = false
  const next = prev.map((state) => {
    if (!state || typeof state !== 'object') return state
    const row = state as Record<string, unknown>
    if (String(row.element_level ?? '').trim().toUpperCase() !== 'PAGE') return state
    const id = String(row.element_id ?? '').trim()
    const name = String(row.element_name ?? '').trim()
    const match = id === targetId || (jsName !== '' && name === jsName)
    if (match) {
      found = true
      return {
        ...row,
        element_level: 'PAGE',
        element_id: Number(targetId) || row.element_id,
        element_name: jsName || row.element_name,
        is_focused: true,
      }
    }
    if (row.is_focused === true) return { ...row, is_focused: false }
    return state
  })
  if (!found && targetId) {
    next.push({
      element_level: 'PAGE',
      element_id: Number(targetId),
      element_name: jsName || undefined,
      is_focused: true,
    })
  }
  return next
}

/**
 * Same channel as page setEnabled: write `is_focused` on the live page object.
 * `setPageData` drops this update. Its commit signature ignores `is_focused`
 * and only fingerprints the first 20 states, so the first Next/Back never
 * reached Section.
 */
export function assignPageFocusStates(
  page: { jsResult?: { states?: unknown[] } | null } | null | undefined,
  pageTarget: PageFocusTarget,
): boolean {
  if (!page) return false
  const prev = Array.isArray(page.jsResult?.states) ? page.jsResult.states : []
  const next = applyPageFocusStates(prev, pageTarget)
  if (!page.jsResult || typeof page.jsResult !== 'object') {
    page.jsResult = { states: next }
    return true
  }
  page.jsResult.states = next
  return true
}
